module.exports = __webpack_public_path__ + "img/error.4e372bd4.svg";